import React, { memo } from 'react'

import {
  AIGenerated,
  BrushAI,
  Button,
  Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, oneOfType, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import CardContent from 'Pods/ThreeDStudio/Shared/CardContent/CardContent'

import { NOOP } from 'Utils/stableDefaults'

// Flat, not AIGeneratedGradientFilled: the gradient variant carries neither `fillable`
// nor `fillable-stroke`, so it ignores the menu's icon colour and stays full-strength
// over the faded label while this action ships disabled.
const useForThreeDIcon = <Icon svgComponent={AIGenerated} color="dark" size={iconSize} />
const editIcon = <Icon svgComponent={BrushAI} color="dark" size={iconSize} />

// Only the image-specific actions live here; the header, Delete and the privacy row come
// from CardContent, shared with ModelCard.
function ImageCardContent({
  createdAt,
  title = '',
  runId = undefined,
  onDelete: handleDelete = NOOP,
  isDeleting = false,
  isPrivate = false,
  canTogglePrivacy = false,
  onTogglePrivacy: handleTogglePrivacy = NOOP,
  isPrivacyUpdating = false,
  isReadOnly = false,
}) {
  const t = useTranslation()

  return (
    <CardContent
      title={title}
      createdAt={createdAt}
      runId={runId}
      onDelete={handleDelete}
      isDeleting={isDeleting}
      isPrivate={isPrivate}
      canTogglePrivacy={canTogglePrivacy}
      onTogglePrivacy={handleTogglePrivacy}
      isPrivacyUpdating={isPrivacyUpdating}
      isReadOnly={isReadOnly}
    >
      {/* Both rows ship disabled rather than hidden, so the entry points stay visible, and
          rather than enabled-and-silent, so neither can read as broken. "Use for 3D
          generation" also needs the hand-off ordering work, which is its own task. */}
      <Button
        type="ghost"
        variant="with-icon"
        icon={useForThreeDIcon}
        size="small"
        customClass="model-card__content-button"
        onClick={NOOP}
        disabled
      >
        {t('imageAssistantPanel.actions.useForThreeDGeneration')}
      </Button>
      <Button
        type="ghost"
        variant="with-icon"
        icon={editIcon}
        size="small"
        customClass="model-card__content-button"
        onClick={NOOP}
        disabled
      >
        {t('imageAssistantPanel.actions.editImage')}
      </Button>
    </CardContent>
  )
}

ImageCardContent.propTypes = {
  createdAt: string.isRequired,
  title: string,
  runId: oneOfType([string, number]),
  onDelete: func,
  isDeleting: bool,
  isPrivate: bool,
  canTogglePrivacy: bool,
  onTogglePrivacy: func,
  isPrivacyUpdating: bool,
  isReadOnly: bool,
}

export default memo(ImageCardContent)
